/* eslint-disable no-unused-vars */

import moment from 'moment';
import { store } from 'redux/store';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

const assignedAndSyncedInspectionManipulationJson = ({
  inspectionCache,
  syncedInspectionCache,
  initialLogin
}) => {
  const { inspection } = store.getState();

  const allInspectionMap =
    _.size(inspection?.inspectionsList) > 0 && !initialLogin
      ? inspection?.inspectionsList.reduce((acc, ins) => {
          acc[ins._id] = true;
          return acc;
        }, {})
      : {};

  const inspectionAll = [
    ...(syncedInspectionCache?.map((ins) => ({
      ...ins,
      status: 'Synced',
      type: 'Inspection',
      id: ins?.inspectionNumber || null,
      _id: ins?.inspectionNumber || null,
      RunName: ins?.runName || null
    })) || []),

    ...(inspectionCache?.map((ins) => ({
      ...ins,
      status: 'To do',
      type: 'Inspection',

      id: uuidv4() || null,
      _id: ins?.inspectableItemId || uuidv4()
    })) || [])
  ];

  let newSyncedInspections = [];
  if (!_.isEmpty(allInspectionMap)) {
    newSyncedInspections = inspectionAll.map((ins) => {
      if (!allInspectionMap[ins._id]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...ins
        };
      } else return ins;
    });
  } else newSyncedInspections = inspectionAll;

  let inspectionAll1 = [
    ...inspection.inspectionsList.filter(
      (t) => t.status === 'Pending sync' || t.status === 'In progress'
    )
  ];

  (newSyncedInspections || []).map((task) => {
    const found = inspectionAll1.findIndex((t) => t.id === task.id || t._id === task._id) + 1;
    if (found) {
      if (!['In progress', 'Pending sync'].includes(inspectionAll1[found - 1].status)) {
        inspectionAll1[found - 1] = { ...task };
      }
    } else {
      inspectionAll1.push({ ...task });
    }
  });

  const inspectionRunMap = {};

  inspectionAll1?.map((inspection) => {
    const { runId, runNumber, RunName, inspectableItemId, inspectionNumber } = inspection;
    if (runId && !inspectionRunMap[runId]) {
      const allInspections = inspectionAll1?.filter((x) => x.runId === runId) || [];
      const allDoneInspections = allInspections?.filter((x) => x?.status === 'Synced') || [];
      const allotDoneInspections = allInspections?.filter((x) => x?.status !== 'Synced') || [];

      const today = moment().format('YYYY-MM-DD');
      const isOverDue = allotDoneInspections?.find((ins) =>
        ins?.dueDate ? moment(ins.dueDate).isBefore(today) : false
      );

      inspectionRunMap[runId] = {
        runId,
        title: RunName,
        id: runNumber,
        allInspections: _.size(allInspections),
        allDoneInspections: _.size(allDoneInspections),
        allotDoneInspections: _.size(allotDoneInspections),
        isOverDue: isOverDue
      };
    }
  });

  return {
    inspectionsList: [...inspectionAll1],
    inspectionRunMap: inspectionRunMap
  };
};

export { assignedAndSyncedInspectionManipulationJson };
